import { Datepicker } from "flowbite-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import {
  FaDownload,
  FaFacebookF,
  FaLine,
  FaRegCalendarAlt,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { getNewsData } from "../api/home";
import {
  formatThaiDate,
  stringHtmlTags,
  toImagePath,
} from "../utils/globalFunctions";
import { tabs } from "./Home";
import { getDocsBook } from "../api/document";

function News() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const [headerTitle, setHeaderTitle] = useState("");
  const [newsData, setNewsData] = useState([]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const newSelected = useMemo(() => {
    scrollToTop();
    return newsData.find((item) => item.cover._id === id);
  }, [id, newsData]);

  console.log("newsData", newsData);
  console.log("newSelected", newSelected);

  const fetchData = useCallback(async () => {
    try {
      const res = await getDocsBook();

      const mapData = res.docsset.map((item) => {
        return {
          ...item,
          image: toImagePath(item?.cover?.path),
          title: item.title,
          datetime: item?.cover?._created,
          content: item.bookdetail,
          url: `/ncsa_book/${item.cover._id}`,
        };
      });

      setNewsData(mapData);
    } catch (err) {
      console.warn(err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main className="site-main">
      <div className="bg-news-intro">
        <img className="" src="/images/hero-image.jpeg" alt="" />
        <div className="headline">
          <h1 className="text-3xl md:text-6xl capitalize">{headerTitle}</h1>
        </div>
      </div>
      <div className="">
        <div
          className={`bg-white p-4 md:p-6 rounded-xl drop-shadow-md container mx-auto relative top-[-4rem] z-10`}
        >
          {/* <div className="news-card" style={{ width: "100%" }}>
            <div className="news-card__slug-header text-4xl">
              {newSelected?.title}
            </div>
            <div className="news-card__slug-main">
              <img
                className="img-aspect-video"
                src={newSelected?.image}
                alt=""
              />
              <div className="flex items-center justify-between py-4">
                <div className="flex items-center text-[#3d3d3d]">
                  <FaRegCalendarAlt className="text-[#3d3d3d]" />
                  <span className="block ml-2">
                    {formatThaiDate(newSelected?.datetime)}
                  </span>
                </div>
                <div className="flex items-center">
                  <span className="block mr-2">แชร์</span>
                  <div className="flex items-center">
                    <div className="bubble-border-red text-md">
                      <FaFacebookF />
                    </div>
                    <div className="ml-2 bubble-border-red text-md">
                      <FaYoutube />
                    </div>
                    <div className="ml-2 bubble-border-red text-md">
                      <FaLine />
                    </div>
                    <div className="ml-2 bubble-border-red text-md">
                      <FaTiktok />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-md text-[#3D3D3D] font-medium">
                <div
                  className="dangerous-html-content"
                  dangerouslySetInnerHTML={{ __html: newSelected?.content }}
                />
              </div>
            </div>
          </div> */}

          {newSelected ? (
            <div>
              <div className="card-title bg-[#E9EAF8] justify-center p-2 text-black">
                {newSelected?.title}
              </div>
              <div className="flex flex-col gap-10">
                <div
                  className="dangerous-html-content"
                  dangerouslySetInnerHTML={{ __html: newSelected?.bookdetail }}
                />
                {/* <p className="px-9 text-black">{newSelected?.bookdetail}</p> */}
                <iframe
                  src={toImagePath(newSelected?.pdflink?.path)}
                  width="100%"
                  height="600px"
                />

                <div className="flex items-center gap-6">
                  <h6>{newSelected?.title}</h6>
                  <button
                    onClick={() =>
                      window.open(toImagePath(newSelected?.pdflink?.path))
                    }
                    className="btn btn-sm text-white btn-error rounded-badge font-light"
                  >
                    <FaDownload />
                    ดาวน์โหลด
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="min-h-[300px] flex items-center justify-center">
              <h4>ไม่พบข้อมูล ที่คุณต้องการ</h4>
            </div>
          )}
        </div>
      </div>

      <div className="news-card__slug-footer">
        <div className="container mx-auto relative">
          <h5 className="text-2xl text-black font-bold px-4">ข่าวล่าสุด</h5>
          <div className="flex flex-auto flex-wrap">
            {newsData.slice(0, 4).map((item, index) => (
              <Link
                key={index}
                to={`/ncsa_book/${item.cover._id}`}
                className="news-card p-2"
              >
                <div className="news-card__image">
                  <img src={item.image} alt="" />
                </div>
                <div className="news-card__time text-sm">
                  <FaRegCalendarAlt />
                  <span>{formatThaiDate(item.datetime)}</span>
                </div>
                <div className="news-card__desc text-md">
                  {stringHtmlTags(item.content)}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}

export default News;
